import React, { useContext } from "react";
import IndustryCard from "../cards/industryCard";
import Slider from "../common/Slider";
import { getSliderSettings } from "./recentJobGroup";
import { IndustryContext } from "../../App";

import { Building2 } from "lucide-react";

function IndustryGroup() {
    const industry = useContext(IndustryContext);

    const settings = getSliderSettings({
        dots: false,
        arrows: false,
        slidesToShow: 3,
        removeAutoPlay: false,
        slidesToShowAt1024Breakpoint: 2,
        slidesToShowAt992Breakpoint: 1,
        objectCount: Object.keys(industry).length,
        speed: 500,
        autoplaySpeed: 2000,
    });

    return (
        <>
            {Object.keys(industry).length === 0 ? null : (
                <section className="cht-py-16 cht-bg-slate-50/50 cht-border-t cht-border-slate-200/80 !cht-font-body">
                    <div className="cht-max-w-7xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8">
                        <header className="cht-text-center cht-mb-10">
                            <span className="cht-inline-flex cht-items-center cht-gap-1.5 cht-px-3.5 cht-py-1.5 cht-rounded-full cht-text-xs cht-font-semibold cht-bg-[#3e57da]/10 cht-text-[#3e57da] cht-mb-3 cht-tracking-wide cht-uppercase">
                                <Building2 className="cht-w-3.5 cht-h-3.5" />
                                Sector Expertise
                            </span>
                            <h2 className="cht-text-3xl sm:cht-text-4xl cht-font-bold !cht-font-heading cht-text-[#1e293b] cht-tracking-tight">
                                Industries We Empower
                            </h2>
                            <p className="cht-text-sm sm:cht-text-base cht-text-slate-600 cht-mt-2.5 cht-max-w-xl cht-mx-auto">
                                Delivering purpose-built software and scalable digital infrastructure across diverse market sectors.
                            </p>
                        </header>

                        <Slider {...settings}>
                            {industry.map((item) => (
                                <div key={item.id}>
                                    <IndustryCard
                                        name={item.name_of_industry}
                                        logo={item.get_logo_url}
                                    />
                                </div>
                            ))}
                        </Slider>
                    </div>
                </section>
            )}
        </>
    );
}

export default IndustryGroup;
